import { ReactNode } from 'react';
import { isMobile } from 'react-device-detect';
import { RouteInstance } from 'atomic-router';

import { theme } from 'shared/styles/theme';
import { Box } from 'shared/ui/Box';
import { Link } from 'shared/ui/Link';
import { ExternalLink, LinkButton } from 'shared/ui/Styled';
import { Flex } from 'shared/ui/StyledComponents';
import { Typography } from 'shared/ui/Typography';

type Props = {
  text: string;
  title?: string;
  date: string;
  params?: string;
  route?: RouteInstance<{ id: string }>;
  link?: string;
  textComponent?: ReactNode;
  checkpointEnd?: string;
  checkpointNumber?: string;
  mentorName?: string;
  managerName?: string;
};

type TextComponentProps = Omit<Props, 'date' | 'title' | 'checkpointEnd' | 'checkpointNumber' | 'mentorName' | 'managerName'>;

const TextComponent = ({ textComponent, text, link, params, route }: TextComponentProps) => {
  if (textComponent) return <Box>{textComponent}</Box>;
  if (link) {
    return (
      <LinkButton>
        <ExternalLink href={link} target='_blank'>
          {text}
        </ExternalLink>
      </LinkButton>
    );
  }

  if (route && params) {
    return (
      <LinkButton>
        <Link to={route} params={{ id: params }}>
          <Typography fontSize={theme.fontSizes['17']}>{text}</Typography>
        </Link>
      </LinkButton>
    );
  }

  return <Typography fontSize={theme.fontSizes['17']}>{text}</Typography>;
};

export const TodoItemContent = ({ text, title, date, params, route, link, textComponent }: Props) => (
  <Flex gap={5} alignItems={isMobile ? '' : 'center'} flexWrap='wrap' padding='3px'>
    <TextComponent text={text} params={params} route={route} link={link} textComponent={textComponent} />
    {title && (
      <Typography fontSize={theme.fontSizes['17']} fontWeight={theme.fontWeights.bold} color={theme.colors.gray800}>
        {title}
      </Typography>
    )}
    {date && <Typography fontSize={theme.fontSizes['17']}>до:</Typography>}
    <Typography fontSize={theme.fontSizes['17']} fontWeight={theme.fontWeights.bold} color={theme.colors.gray800}>
      {date}
    </Typography>
  </Flex>
);
